// eslint-disable-next-line import/no-named-as-default
import gql from 'graphql-tag'
import { imageFields } from '../elements/imageFragment.graphql'

export const lessonFields = gql`
  fragment lessonFields on LessonRecord {
    modelApiKey: _modelApiKey
    slug
    title
    description
    lessonNumber
    cta
    readingTimeInMinutes
    image {
      ...imageFields
    }
  }
  ${imageFields}
`
